import React from 'react';
import { useSelector } from 'react-redux';

import Alert from '@fmbt/ui/Alert';
import { LoadingSpinnerDiv } from '@fmbt/ui/LoadingSpinner';
import { useBackOfficeUser } from 'store/modules/backOfficeUser/hooks';
import { makeSelectFirstErrorMessage } from 'store/modules/error/selectors';
import { UserId } from 'types/models/user';

const actions = ['LOAD_BACK_OFFICE_USER'];

export const selectErrorMessage = makeSelectFirstErrorMessage(actions);

interface Props {
  children: JSX.Element;
  userId: UserId | undefined;
}

function BackOfficeUserLoadingGate({ children, userId }: Props): JSX.Element {
  const backOfficeUser = useBackOfficeUser();
  const errorMessage = useSelector(selectErrorMessage);

  if (backOfficeUser && backOfficeUser.id === userId) {
    return children;
  }

  if (errorMessage) {
    return <Alert message={errorMessage} />;
  }

  return <LoadingSpinnerDiv />;
}

export default BackOfficeUserLoadingGate;
